module.exports = __webpack_public_path__ + "img/wjdc.c36f5f35.svg";